import { render } from "./TableSkeleton.vue?vue&type=template&id=68c46fd4"
import script from "./TableSkeleton.vue?vue&type=script&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&lang=js"

import "./TableSkeleton.vue?vue&type=style&index=0&id=68c46fd4&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__